module.exports = "<app-left-nav *ngIf=\"this.authService.isAuthenticated()\"></app-left-nav>\n<section>\n  <div [ngClass]=\"this.authService.isAuthenticated() ? 'main-panel' : ''\">\n    <app-header *ngIf=\"this.authService.isAuthenticated()\"></app-header>\n    <router-outlet></router-outlet>\n  </div>\n</section>\n<app-footer *ngIf=\"this.authService.isAuthenticated()\"></app-footer>"


//////////////////
// WEBPACK FOOTER
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/shared/authenticate/authenticate.component.html
// module id = ../../../../../src/app/shared/authenticate/authenticate.component.html
// module chunks = main